import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

export const GEOLOCATION_STATUS = {
  IDLE: 'idle',
  WAITING: 'waiting',
  FIXED: 'fixed',
  ERROR: 'error'
}

const initialState = {
    status: GEOLOCATION_STATUS.IDLE,
    highAccuracy: false,
    error: null
}

const geolocationSlice = createSlice({
  name: 'geolocation',
  initialState,
  reducers: {
    setHighAccuracy(state, action) {
      state.highAccuracy = action.payload
    },
    updateGeolocation(state, action) {
      Object.assign(state, action.payload) 
    }
  }
})


export const useGeolocation = () => useSelector( state => state.geolocation ),
             useGeolocationError = () => useSelector( state => state.geolocation && state.geolocation.error )
export const { setHighAccuracy, updateGeolocation } = geolocationSlice.actions
export default geolocationSlice
